export const getLanguageCode = (): string => {
  const lang = document.documentElement.getAttribute('lang') || 'en'
  return lang.split('_')[0].split('-')[0].toLowerCase()
}
